module.exports = __webpack_public_path__ + "img/enemy_121_001.a84dc18c.png";